import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import orderAPI from '../services/orderAPI';
import { useTranslate } from './useTranslate';

// Reorder at current menu prices. The server rebuilds the cart and skips dishes that are gone.
export default function useReorder(onMessage) {
  const t = useTranslate();
  const navigate = useNavigate();
  const [isReordering, setIsReordering] = useState(false);

  const reorder = useCallback(async (orderId, replaceCart = false) => {
    if (!orderId) return;
    setIsReordering(true);
    try {
      const result = await orderAPI.reorder(orderId, { replaceCart });
      const skipped = result?.skipped || [];
      if (skipped.length) {
        onMessage?.({ type: 'error', text: `${t("No longer available")}: ${skipped.map((i) => i.name).join(', ')}` });
      }
      navigate('/checkout');
    } catch (err) {
      if (err?.response?.status === 409) {
        setIsReordering(false);
        if (window.confirm(t("Your cart already has items. Replace them with this order?"))) {
          await reorder(orderId, true);
        }
        return;
      }
      onMessage?.({ type: 'error', text: err?.response?.data?.message || t("Failed to reorder items. Please try again.") });
    } finally {
      setIsReordering(false);
    }
  }, [navigate, onMessage, t]);

  return { reorder, isReordering };
}
